let constants = {
  CONTAINS: "Contains",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  EDIT: "Edit",
  ADD: "Add",
  CONFIRMATION_BOX_CONFIG: {
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true,
    showCloseButton: true,
    customClass: "swal-confirmation",
  },
};

module.exports = Object.freeze(constants);
